import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';

import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

import { getRequestsVessel } from 'actions/vessels/request';
import Item from './Item';
import { EhSelector } from 'components/Base/EhSelector';

const styles = {
    radioGroup: {
        margin: '20px 0',
    },
    radioButton: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '25%',
    },
    paginationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: '.5em',
        fontSize: '.75em'
    },
    paginationSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paginationText: {
        margin: '0 1.25em'
    },
    paginationSelect: {
        width: 75,
        fontSize: '1em'
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer'
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)'
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer'
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)'
    }
};

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            filters: {
                search: '',
                eh: [],
            },
        };

        this.updateRows = this.updateRows.bind(this);
        this.handleSearch = this.handleSearch.bind(this);

        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.handleEhChange = this.handleEhChange.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            page: props.vesselRequests.page,
        });
    }

    nextPage() {
        this.setState({
            page: this.props.vesselRequests.next,
        }, () => {
            this.updateRows(this.state);
        });
    }

    prevPage() {
        this.setState({
            page: this.props.vesselRequests.previous,
        }, () => {
            this.updateRows(this.state);
        });
    }

    updateRows(state) {
        this.props.getRequestsVessel({
            page: state.page,
            filters: {
                all: true,
                search: state.filters.search.length !== 0 ? state.filters.search : undefined,
                eh: state.filters.eh,
            },
            sort: {
                field: 'addedAt',
                value: -1,
            },
        });
    }

    handleSearch() {
        this.setState({
            page: 1,
            filters: {
                ...this.state.filters,
                search: this.refs.search.input.value,
            },
        }, () => {
            this.updateRows(this.state);
        });
    }

    handleEhChange(eh) {
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                eh,
            }
        }, () => {
            this.updateRows(this.state);
        });
    }

    render() {
        const vesselRequests = this.props.vesselRequests;
        const vesselRequestsItems = vesselRequests.data;

        if (!vesselRequestsItems) {
            return null;
        }

        return (
            <div>
                <div className='filter'>
                    <div className='filter-row'>
                        <div className='search filter-column' style={{ width: '100%', justifyContent: 'space-between', }}>
                            <TextField
                                defaultValue={this.state.search}
                                floatingLabelText='Search'
                                ref='search'
                                onKeyPress={(event) => {
                                    if (event.charCode === 13) {
                                        event.preventDefault();
                                        this.handleSearch();
                                    }
                                }}
                            />
                            <EhSelector values={this.state.filters.eh} onChange={this.handleEhChange} />
                            <span style={{ display: 'flex', alignItems: 'center', }}>
                                <IconButton
                                    iconStyle={styles.navigationLeft}
                                    name='navigationLeft'
                                    onClick={this.prevPage}
                                >
                                    <ChevronLeft />
                                </IconButton>
                                <div className='item'>Page: {this.state.page}</div>
                                <IconButton
                                    iconStyle={styles.navigationRight}
                                    name='navigationRight'
                                    onClick={this.nextPage}
                                >
                                    <ChevronRight />
                                </IconButton>
                            </span>
                            <RaisedButton
                                label='Search'
                                style={{ fontSize: '13px', margin: '0 0 0 10px' }}
                                primary
                                onClick={this.handleSearch}
                            />
                        </div>                        
                    </div>

                    <div>
                        <ul className='list-requests'>
                            {
                                vesselRequestsItems.map(item => <Item key={item._id} item={item} />)
                            }
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            vesselRequests: state.vesselRequests,
        };
    },
    dispatch => bindActionCreators({
        getRequestsVessel,
    },
    dispatch),
)(List);



// WEBPACK FOOTER //
// ./app/components/Vessels/Requests/List.jsx